import { render } from "./select.html?vue&type=template&id=5ff40eba&scoped=true&external"
import script from "./select.ts?vue&type=script&lang=js&external"
export * from "./select.ts?vue&type=script&lang=js&external"

import "./select.scss?vue&type=style&index=0&id=5ff40eba&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ff40eba"],['__file',"src/components/ui/select/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5ff40eba"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5ff40eba', __exports__)) {
    api.reload('5ff40eba', __exports__)
  }
  
  module.hot.accept("./select.html?vue&type=template&id=5ff40eba&scoped=true&external", () => {
    api.rerender('5ff40eba', render)
  })

}


export default __exports__